//TODO refatorar: mudar atributo 'text' para 'content'
import React from 'react'
import PropTypes from 'prop-types'
import './style.css'

const MCEadInputLabel = (props) => {
    return (
        <span className='mc-ead-input-label' style={props.style}>{props.text}</span>
    )
}

MCEadInputLabel.propTypes = {
    text: PropTypes.any.isRequired
}

MCEadInputLabel.defaultProps = {}

export default MCEadInputLabel



// WEBPACK FOOTER //
// ./src/components/_ead/InputLabel/index.js